/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { compose, bindActionCreators } from "redux";
import { connect } from "react-redux";
import { loadDocumentScoringHistorySession, loadDocumentScoringHistory } from "../actionCreators";
import DocumentScoringGridComponent from "features/document/edit/scoring/components/DocumentScoringGridComponent";
import { RightsContext } from "providers/RightsContext";
import { getScoringGridsHistory } from "../selectors";

export const DocumentScoringSessionHistoryContainer = ({ scoringGrids, sessionID, documentId, siteId, actions }) => {
  const {
    scoringScoringSummaryRead,
    scoringKoRead,
    scoringGridDocumentRead,
    scoringGridClientRead,
    scoringGridAssetRead
  } = useContext(RightsContext);

  useEffect(() => {
    if (hasNoRights()) {
      return;
    }

    actions.loadDocumentScoringHistory(documentId, siteId, sessionID);
    actions.loadDocumentScoringHistorySession(documentId, siteId, sessionID);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(
    () => {
      if (hasNoRights()) {
        return;
      }

      actions.loadDocumentScoringHistory(documentId, siteId, sessionID);
      actions.loadDocumentScoringHistorySession(documentId, siteId, sessionID);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [scoringScoringSummaryRead, scoringKoRead, scoringGridDocumentRead, scoringGridClientRead, scoringGridAssetRead]
  );

  const hasNoRights = () => {
    return (
      !scoringScoringSummaryRead &&
      !scoringKoRead &&
      !scoringGridDocumentRead &&
      !scoringGridClientRead &&
      !scoringGridAssetRead
    );
  };

  return (
    <Fragment>
      {scoringGrids &&
        scoringGrids.length > 0 &&
        scoringGrids.map(s => (
          <DocumentScoringGridComponent
            key={s.documentScoringAnalysisHistoryId}
            documentId={documentId}
            siteId={siteId}
            scoringGrid={s}
            isHistory={true}
          />
        ))}
    </Fragment>
  );
};

DocumentScoringSessionHistoryContainer.propTypes = {
  scoringGrids: PropTypes.array.isRequired,
  sessionID: PropTypes.string.isRequired,
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  actions: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
  const key = `${ownProps.documentId}-${ownProps.siteId}`;
  return {
    scoringGrids: getScoringGridsHistory(state, key, ownProps.sessionID)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ loadDocumentScoringHistorySession, loadDocumentScoringHistory }, dispatch),
    dispatch
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(DocumentScoringSessionHistoryContainer);
